import { render, staticRenderFns } from "./Question6.vue?vue&type=template&id=6659731b&scoped=true&"
import script from "./Question6.vue?vue&type=script&lang=js&"
export * from "./Question6.vue?vue&type=script&lang=js&"
import style0 from "./Question6.vue?vue&type=style&index=0&id=6659731b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659731b",
  null
  
)

export default component.exports